import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { StepPreviewComponent } from '../../step-preview/step-preview.component';
import { MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-congrats',
    standalone: false,
    templateUrl: './congrats.component.html',
    styleUrl: './congrats.component.scss'
})
export class CongratsComponent implements OnInit {
    dia = inject(MatDialogRef<StepPreviewComponent>)
    private destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.dia.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.close();
                    }
                },
            });
    }

    close() {
        this.dia.close();
    }
    data = [
        {
            title: "Share & Edit your Key Results.",
            description: "Easily edit and send your work to teammates, coachers, or investors in one click."
        },
        {
            title: "Turn your idea into a real landing page",
            description: "Build a simple, beautiful page or other visual hand-off assets to showcase your idea to the world."
        },
        {
            title: "So much more coming soon...",
            description: "We have some great features under development right now. Make sure you follow us to not miss a thing."
        }
    ]
}

